export default function ArrowNoTail({ className }) {
  return (
    <svg
      viewBox="0 0 32 32"
      height="100%"
      width="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4 14.6667L29.3333 2.66669L17.3333 28L14.6667 17.3334L4 14.6667Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
